import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IDeliveryMethod } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

interface ICreateDeliveryMethodPayload {
  title: string;
  description: string;
  fee: string;
  is_home_delivery: boolean;
}

const useCreateDeliveryMethod = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ICreateDeliveryMethodPayload) => {
      return fetch(`${API}/api/semeadora/delivery-methods-manage/`, {
        method: "POST",
        body: payload,
      }) as Promise<IDeliveryMethod>;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["delivery-methods"]);
      },
    },
  );
};

export default useCreateDeliveryMethod;
